import styled from '@emotion/styled'
import { Colors, Fonts } from '../../styles/Variables'

export const Page = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100vw;
    height: 100vh;
    background-color: ${Colors.bianca};

    #signinDiv {
        margin-top: 40px;
    }
`
export const Title = styled.h2`
    margin-top: 42px;
    font-family: ${Fonts.fontDefault};
    font-weight: 400;
    font-size: 26px;
`
